import React, { Component } from "react";
import Heading from "../Heading/Heading";
import TwoColumns from "../TwoColumns/TwoColumns";
import Input from "../Input/Input";
import VideoThumbnail from "../VideoThumbnail/VideoThumbnail";
import VotingBanner from "../VotingBanner/VotingBanner";

import "./FilterableVideoList.css";
import { categoryOptions, voteLimit } from "../../config";

export default class FilterableVideoList extends Component {
  state = {
    filter: "",
    selectedCategory: null,
    selectedVideos: [],
    videos: this.randomizeVideos()
  };

  randomizeVideos() {

	if(!this.props || !this.props.videos) return;

    // We have to cache videos in state as doing it at render time would cause order to change
    const videos = {};
    const sortedVideos = Object.keys(this.props.videos).sort(
      (a, b) => Math.floor(Math.random() * 2) * 2 - 1
    );
    sortedVideos.forEach(videoId => {
      videos[videoId] = this.props.videos[videoId];
    });
    return videos;
  }

  toggleCategory = key => {
    if (this.state.selectedCategory === key || key === 'all') {
      this.setState({
        selectedCategory: null
      });
    } else {
      this.setState({
        selectedCategory: key
      });
    }
  };

  handleFilterChange = e => {
    this.setState({
      filter: e.target.value
    });
  };

  videoFilters = ([videoId, video]) => {
    const shortlistFilter = video.shortlisted;
    const categoryFilter = video.category === this.state.selectedCategory;
    const nameFilter =
      video.title.toLowerCase().indexOf(this.state.filter.toLowerCase()) !==
        -1 ||
      video.name.toLowerCase().indexOf(this.state.filter.toLowerCase()) !== -1;
    if (this.state.filter && this.state.selectedCategory) {
      return shortlistFilter && categoryFilter && nameFilter;
    }

    if (this.state.filter) {
      return shortlistFilter && nameFilter;
    }

    if (this.state.selectedCategory) {
      return shortlistFilter && categoryFilter;
    }

    return shortlistFilter;
  };

  toggleVideo = id => {
    const selected = this.state.selectedVideos.indexOf(id) !== -1;
    if (!selected && this.state.selectedVideos.length >= voteLimit) {
      return;
    }
    this.setState({
      selectedVideos: selected
        ? this.state.selectedVideos.filter(s => s !== id)
        : [...this.state.selectedVideos, id]
    });
  };

  render() {
    return (
      <div className="FilterableVideoList">
        <TwoColumns
          sidebarLayout
          left={
            <div className="FilterableVideoList__sidebar">
              <h4>Categories</h4>
              {categoryOptions && Object.entries(categoryOptions).map(([key, option]) => (
                <div
                  key={key}
                  onClick={e => {
                    e.preventDefault();
                    this.toggleCategory(key);
                  }}
                  className={
                    this.state.selectedCategory === key || (this.state.selectedCategory === null && key === 'all')
                      ? "FilterableVideoList__category FilterableVideoList__category--selected"
                      : "FilterableVideoList__category"
                  }
                >
                  {option}
                </div>
              ))}
            </div>
          }
          right={
            <div className="FilterableVideoList__content">
              <div className="FilterableVideoList__contentHeader">
                <Heading>{this.props.title || "Entries"}</Heading>
                <Input
                  value={this.state.filter}
                  onChange={this.handleFilterChange}
                  placeholder="Search"
                />
              </div>
              <div className="FilterableVideoList__videos">
                {this.state.videos && Object.entries(this.state.videos)
                  .filter(this.videoFilters)
                  .map(([videoId, video]) => (
                    <div
                      className="FilterableVideoList__videosItem"
                      key={videoId}
                    >
                      <VideoThumbnail
                        competitionSlug={this.props.competitionSlug}
                        video={video}
                        id={videoId}
                        votingMode={this.props.votingMode}
                        selected={
                          this.state.selectedVideos.indexOf(videoId) !== -1
                        }
                        toggleVideo={() => this.toggleVideo(videoId)}
                      />
                    </div>
                  ))}
              </div>
            </div>
          }
        />
        {this.props.votingMode && (
          <VotingBanner
            count={this.state.selectedVideos.length}
            submitVotes={() =>
              this.props.submitVotes(this.state.selectedVideos)
            }
          />
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/FilterableVideoList/FilterableVideoList.js